import { Button, Col, Descriptions, Row } from "antd";
import to from "await-to-js";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";

import { Modal } from "../../../../../components/Modal/Modal";
import { ModalsContext } from "../../../../../context/modals.context";
import { trackAndTraceService } from "../../../../../modules/trackAndTrace/trackAndTrace.service";
import { ITtKodDetalji } from "../../../../../modules/trackAndTrace/trackAndTrace.types";
import style from "./TrackInfoModal.module.scss";

export const TrackInfoModal = () => {
  const { isModalVisible, clearModals, modals } = useContext(ModalsContext);
  const [codeData, setCodeData] = useState<ITtKodDetalji | null>(null);

  const codeId = modals.ttId;
  const tipPakovanjaId = modals.tipPakovanjaId;
  const title = modals.infoTitle;

  const onOk = () => {
    clearModals();
  };

  const getTtCodeDetails = async () => {
    if (!codeId || !tipPakovanjaId) return;
    const [err, res] = await to(
      trackAndTraceService.postTtDetaljiIstorije(codeId, tipPakovanjaId)
    );
    if (err || !res?.success) return;
    setCodeData(res.data);
  };

  useEffect(() => {
    if (!codeId || !tipPakovanjaId) return;
    getTtCodeDetails();
  }, [modals.ttId, modals.tipPakovanjaId]);

  return (
    <Modal
      name="track-trace-info"
      title={title}
      footer={false}
      open={isModalVisible("trackInfo")}
      onCancel={clearModals}
      width={1150}
    >
      <Row className={style.brandTableHeaderRow}>
        <Col span={3} className={style.brandTableHeader}>
          {t("TRACK.PAKOVANJE_TIP")}
        </Col>
        <Col span={3} className={style.brandTableHeader}>
          {t("TRACK.KOLICINA")}
        </Col>
        <Col span={3} className={style.brandTableHeader}>
          {t("TRACK.BREND_SIFRA")}
        </Col>
        <Col span={3} className={style.brandTableHeader}>
          {t("TRACK.BREND_NAZIV")}
        </Col>
        <Col span={3} className={style.brandTableHeader}>
          {t("TRACK.SERIJSKI_BROJ_MASINE")}
        </Col>
        <Col span={3} className={style.brandTableHeader}>
          {`       `}
          {t("TRACK.MODEL_MASINE")}
        </Col>
        <Col span={3} className={style.brandTableHeader}>
          {t("TRACK.PROIZVODJAC_MASINE")}
        </Col>
        <Col span={3} className={style.brandTableHeader}>
          {t("TRACK.BROJ_CIGARETA")}
        </Col>
      </Row>

      {codeData?.brendDetalji?.map((brend) => (
        <Row className={style.brandTableRow}>
          <Col span={3} className={style.brandTableColumn}>
            {brend?.pakovanjeTip}
          </Col>
          <Col span={3} className={style.brandTableColumn}>
            {brend?.kolicina}
          </Col>
          <Col span={3} className={style.brandTableColumn}>
            {brend?.brendSifra}
          </Col>
          <Col span={3} className={style.brandTableColumn}>
            {brend?.brendNaziv}
          </Col>
          <Col span={3} className={style.brandTableColumn}>
            {brend?.serijskiBrojMasine}
          </Col>
          <Col span={3} className={style.brandTableColumn}>
            {brend?.modelMasine}
          </Col>
          <Col span={3} className={style.brandTableColumn}>
            {brend?.proizvodjacMasina}
          </Col>
          <Col span={3} className={style.brandTableColumn}>
            {brend?.brojCigaretaUPojedinacnomPakovanju}
          </Col>
        </Row>
      ))}
      <div className={style.deliveryStatus}>
        <Descriptions
          column={1}
          className={style.description}
          items={[
            ...(codeData?.planiranoVremeIsporuke
              ? [
                  {
                    label: t("TRACK.PLANIRANO_VREME_ISPORUKE"),
                    children: codeData?.planiranoVremeIsporuke,
                  },
                ]
              : []),
            ...(codeData?.pretovar
              ? [
                  {
                    label: t("TRACK.PRETOVAR"),
                    children: codeData?.pretovar,
                  },
                ]
              : []),
            ...(codeData?.vozilo
              ? [
                  {
                    label: t("TRACK.VOZILO"),
                    children: codeData?.vozilo,
                  },
                ]
              : []),
            ...(codeData?.napomena
              ? [
                  {
                    label: t("TRACK.NAPOMENA"),
                    children: codeData?.napomena,
                  },
                ]
              : []),
            ...(codeData?.brojOtpremnice
              ? [
                  {
                    label: t("TRACK.BROJ_OTPREMNICE"),
                    children: codeData?.brojOtpremnice,
                  },
                ]
              : []),
            ...(codeData?.statusOtpremnice
              ? [
                  {
                    label: t("TRACK.STATUS_OTPREMNICE"),
                    children: codeData?.statusOtpremnice,
                  },
                ]
              : []),
          ]}
        />
        <div className={style.buttonContainer}>
          <Button type="primary" onClick={onOk}>
            {t("COMMON.ZATVORI")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
